<template>
  <div class="app-header">
    <div class="header-left">
      <h1>云安管家</h1>
    </div>
    <div class="header-right">
      <div class="user-info">
        <el-avatar :size="32" :src="user?.avatar || ''">
          {{ user?.name?.charAt(0).toUpperCase() }}
        </el-avatar>
        <span class="username">{{ user?.name }}</span>
      </div>
      <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link">
          <el-icon><ArrowDown /></el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="profile">个人资料</el-dropdown-item>
            <el-dropdown-item command="settings">系统设置</el-dropdown-item>
            <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ArrowDown } from '@element-plus/icons-vue'

export default {
  name: 'AppHeader',
  components: {
    ArrowDown
  },
  setup() {
    const router = useRouter()
    const userInfo = ref(null)
    
    // 加载用户信息
    const loadUserInfo = () => {
      try {
        const userData = localStorage.getItem('user')
        if (userData) {
          userInfo.value = JSON.parse(userData)
          console.log('User info loaded:', userInfo.value) // 调试用
        } else {
          userInfo.value = null
        }
      } catch (error) {
        console.error('Failed to load user info:', error)
        userInfo.value = null
      }
    }
    
    const user = computed(() => userInfo.value)
    
    // 监听localStorage变化
    onMounted(() => {
      loadUserInfo()
      
      // 监听storage事件
      const handleStorageChange = () => {
        loadUserInfo()
      }
      
      window.addEventListener('storage', handleStorageChange)
      
      // 清理函数
      onBeforeUnmount(() => {
        window.removeEventListener('storage', handleStorageChange)
      })
    })
    
    const handleCommand = async (command) => {
      switch (command) {
        case 'profile':
          ElMessage.info('个人资料功能开发中...')
          break
        case 'settings':
          ElMessage.info('系统设置功能开发中...')
          break
        case 'logout':
          try {
            await ElMessageBox.confirm('确定要退出登录吗？', '确认退出', {
              type: 'warning'
            })
            // 清理所有登录信息
            localStorage.removeItem('user')
            localStorage.removeItem('family')
            localStorage.removeItem('token')
            userInfo.value = null // 立即更新组件状态
            ElMessage.success('已退出登录')
            router.push('/login')
          } catch (error) {
            // 用户取消
          }
          break
      }
    }
    
    return {
      user,
      handleCommand,
      loadUserInfo // 暴露这个方法，以便其他地方调用
    }
  }
}
</script>

<style scoped>
.app-header {
  background: white;
  padding: 0 20px;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  position: relative;
  z-index: 1000;
}

.header-left h1 {
  margin: 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.username {
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.el-dropdown-link {
  cursor: pointer;
  color: #606266;
  display: flex;
  align-items: center;
  padding: 5px;
  border-radius: 4px;
  transition: all 0.3s;
}

.el-dropdown-link:hover {
  background-color: #f5f7fa;
  color: #409EFF;
}
</style>